<template>
  <div class="relative">
    <select
      :value="currencyState.code"
      @change="setCurrency($event.target.value)"
      class="cursor-pointer appearance-none rounded-lg border border-gray-200 bg-white py-2 pl-3 pr-7 text-sm font-semibold text-gray-700 hover:border-amber-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
      aria-label="Select currency"
    >
      <option v-for="c in CURRENCIES" :key="c.code" :value="c.code">{{ c.symbol }} {{ c.code }}</option>
    </select>
    <svg class="pointer-events-none absolute right-2 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-gray-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </div>
</template>

<script>
import { CURRENCIES, currencyState, setCurrency } from '../services/currencyStore'

export default {
  name: 'CurrencySwitcher',
  data() {
    return {
      CURRENCIES,
      currencyState
    }
  },
  methods: {
    setCurrency
  }
}
</script>
